<template>
    <router-link :to="link" class="preview">
        <h2 v-text="title"></h2>
        <img :src="imgUrl" alt="">
    </router-link>
</template>

<script>
    export default {
        name: "VideoPreview",
        props: {
            video: { required: true },
        },
        computed: {
            videoObj() {
                return this.$store.getters['videos/id'](this.video.id)
            },
            imgUrl() {
                if( this.videoObj == null ) {
                    return ""
                }
                return this.videoObj.thumbnail_url
            },
            link() {
                if( this.videoObj == null ) {
                    return ""
                }
                return {
                    name: 'home_video',
                    params: {video_id: this.videoObj.slug},
                }
            },
            title() {
                return this.video.title
            },
        },
        watch: {
            videoObj: {
                immediate: true,
                handler() {
                    if( this.videoObj != null ) {
                        return
                    }
                    this.$store.dispatch('videos/getOne', this.video.id)
                },
            },
        },
    }
</script>

<style scoped lang="scss">
.preview {
    display: grid;
    grid-template-columns: 1fr min-content;
    grid-template-rows: min-content 1fr;
    grid-template-areas: 
        "title img"
        "excerpt img"
        ;

    h2 {
        grid-area: title;
    }

    img {
        grid-area: img;
        height: 12rem;
        width: calc(12rem * 16 / 9);
        object-fit: cover;
    }

    .excerpt {
        grid-area: excerpt;
    }
}
</style>
